import React, { useEffect } from 'react';
import Logo from 'components/Logo'
import LogoutButton from 'components/LogoutButton';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    position: `fixed`,
    left: 0,
    top: 0,
    background: '#383737',
    maxWidth: 80,
    minWidth: 80,
    height: '100%',
    zIndex: 2
  },
}));

function SideBarMenu(props) {
  const classes = useStyles(); 
  const states = useSelector(state => {
    return state.globalStates
  })
  return(
    <div id={ `sidebar-ops-ui` } className={ classes.root }>
      <Logo/>
      <LogoutButton />
    </div>
  )
}

export default SideBarMenu;